import { UiLoaderAnimationVanilla } from '../../Loaders/UiLoaderAnimation/UiLoaderAnimationVanilla'

const getClassName = (className, needClass) => {
  return needClass ? className : ''
}

const getButtonClassList = ({ theme, shape, size, sizeMode, isLoading, isActive }) => {
  return `ui-icon-button
    ui-icon-button--${theme}
    ui-icon-button--${shape}
    ui-icon-button--${size}
    ${getClassName(`ui-icon-button--${sizeMode}`, sizeMode)}
    ${getClassName('ui-icon-button--loading', isLoading)}
    ${getClassName('ui-icon-button--active', isActive)}
  `
}

const getIconClassList = ({ size, sizeMode }) => {
  return `ui-icon-button__icon
    ui-icon-button__icon--${size}
    ${getClassName(`ui-icon-button__icon--${sizeMode}`, sizeMode)}
  `
}

const getIconTemplate = ({ icon, iconClassList }) => {
  return `<svg 
      class="${iconClassList}"
      width="20"
      height="20"
      aria-hidden="true"
    >
      <use href="#${icon}"></use>
    </svg>
  `
}

const getLoaderTemplate = ({ isLoading, size }) => {
  return `
    ${isLoading ? UiLoaderAnimationVanilla({ classes: `ui-icon-button__loader ui-icon-button__loader--${size}` }) : ''}
  `
}

const getLinkTemplate = ({ buttonClassList, classes, href, ariaLabel, attrs, icon, iconClassList, isLoading, size }) => {
  return `<a
    class="${buttonClassList} ${classes}"
    href="${href}"
    aria-label="${ariaLabel}"
    ${attrs}
  >
    ${icon ? getIconTemplate({ icon, iconClassList }) : ''}

    ${getLoaderTemplate({ isLoading, size })}
  </a>`
}

const getNotInteractiveTemplate = ({ buttonClassList, classes, ariaLabel, attrs, icon, iconClassList, isLoading, size }) => {
  return `<span
    class="${buttonClassList} ${classes}"
    aria-label="${ariaLabel}"
    ${attrs}
  >
    ${icon ? getIconTemplate({ icon, iconClassList }) : ''}
        
    ${getLoaderTemplate({ isLoading, size })}
  </span>`
}

const getButtonTemplate = ({ buttonClassList, classes, type, ariaLabel, attrs, icon, iconClassList, isLoading, size }) => {
  return `<button
    class="${buttonClassList} ${classes}"
    type="${type}"
    aria-label="${ariaLabel}"
    ${attrs}
  >
    ${icon ? getIconTemplate({ icon, iconClassList }) : ''}
    
    ${getLoaderTemplate({ isLoading, size })}
  </button>`
}

export const UiIconButtonVanilla = (
  {
    isLoading = false,
    type = 'button',
    href = null,
    theme = 'filled-main',
    size = 'small',
    sizeMode = null,
    shape = 'circle',
    icon = null,
    ariaLabel = '',
    notInteractive = false,
    isActive = false,
    classes = '',
    attrs = ''
  }
) => {
  const buttonClassList = getButtonClassList({ theme, shape, size, sizeMode, isLoading, isActive })
  const iconClassList = getIconClassList({ size, sizeMode })
  const options = { type, href, icon, ariaLabel, buttonClassList, iconClassList, classes, attrs }

  if (href) {
    return getLinkTemplate(options)
  } else if (notInteractive) {
    return getNotInteractiveTemplate(options)
  } else {
    return getButtonTemplate(options)
  }
}
